export type LocalizedText = { languageID: string; text: string }[];

export type OptionWithText = {
	key: string;
	text: LocalizedText;
};

export type OptionsUpdate<T extends OptionWithText> = T[] | ((current: T[]) => T[]);

// Keeps every other language and writes `text` under the library language.
export function mergeLocalizedText(
	entries: LocalizedText,
	languageID: string,
	text: string,
): LocalizedText {
	return entries.filter((entry) => entry.languageID !== languageID).concat([{ languageID, text }]);
}

export function resolveOptionsUpdate<T extends OptionWithText>(
	current: T[],
	next: OptionsUpdate<T>,
): T[] {
	return typeof next === 'function' ? next(current) : next;
}

export function replaceOptionText<T extends OptionWithText>(
	options: T[],
	key: string,
	languageID: string,
	text: string,
): T[] {
	return options.map((option) =>
		option.key === key
			? { ...option, text: mergeLocalizedText(option.text, languageID, text) }
			: option,
	);
}
